import HomePage from '@/components/pages/homepage/HomePage';
import BusinessCardsNew from '@/components/pages/homepage/BusinessCardsNew';
import store from '@/store/store';

let routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
    meta:{
      title:"Brandly | Business Cards for Growing Teams"
    }
  },
  {
    // Redirect from /papers (printed on sample packs) to the most appropriate place
    path: "/papers",
    redirect: "/business-cards"
  },
  {
    // Redirect from /products (linked from the blog) to the most appropriate place
    path: "/products",
    redirect: "/business-cards"
  },
  {
    path: "/business-cards/:slug?",
    name: "Catalog",
    component: BusinessCardsNew,
    props: true,
    meta: {
      title: "Brandly | Products",
    }
  },
  {
    path: "/blog",
    beforeEnter() {
      if (window.location.pathname != '/blog/') {
        window.location = "/blog/";
      }
    }
  },
  {
    path: "/get",
    redirect: "/signup"
  }
];

/***** Automatic route logic *****
 * Any files in components/pages/homepage become routes, ie SignIn.vue becomes /signin
 * The file can include a 'meta' key in the default export to override the default title logic.
 * eg:
 *
 * <script>
 * export default {
 *   meta: {title: "Foo"}
 * }
 * </script>
 *
 * Only files in the top level and under bubsinesscard/ are included,
 * subdirectories can be included by following the format used by businesscards.
 *
 * If the component has props they become OPTIONAL segments in the route.
 * Eg ResetPassword.vue has props uid, token
 * /resetpassword routes to the component, as does /resetpassword/1/123
 */
addRoutes(require.context('@/components/pages/homepage', true, /^\.\/\w+\.vue$/));
export default routes;


function addRoutes(context_module, path='') {
  context_module.keys().forEach(key => addRoute(path+key.replace(/^.\/|\.vue/g,''), context_module(key)));
}
function addRoute(file, module) {
  const component = module.default;
  const path = '/'+file.toLowerCase();
  const meta = component.meta || {};
  const [name] = file.split('/').slice(-1);
  if (!meta.title) meta.title = `Brandly | ${name.replace(/([a-z])([A-Z])/g, "$1 $2")}`;
  let route = {name, path, component, meta};

  if (component.props) {
    let propnames = Array.isArray(component.props) ? component.props : Object.keys(component.props);
    route.path += propnames.map(s => `/:${s}?`).join('');
    route.props = true;
  }
  routes.push(route);
}



// WEBPACK FOOTER //
// ./src/router/homepage.js